'use strict'
import notify from "@/utils/notify"

const PDQ_BASE_URL = 'http://localhost:8888/api'

export default {
  async listDevice() {
    try {
      const response = await fetch(`${PDQ_BASE_URL}/listDevice`)
      const data = await response.json()
      
      if (data.ErrCode === 0) {
        return { success: true, device: data.ErrMsg }
      } else {
        notify.alert.error('Failed to list PDQ device')
        return { success: false, error: data.ErrMsg }
      }
    } catch (error) {
      notify.alert.error('PDQ device not connected or service unavailable')
      return { success: false, error: error.message }
    }
  },

  async connectDevice() {
    try {
      const response = await fetch(`${PDQ_BASE_URL}/connectDevice`)
      const data = await response.json()
      
      if (data.ErrCode === 0) {
        notify.alert.success('PDQ device connected successfully')
        return { success: true, device: data.ErrMsg }
      } else {
        notify.alert.error('Failed to connect PDQ device')
        return { success: false, error: data.ErrMsg }
      }
    } catch (error) {
      notify.alert.error('PDQ connection failed')
      return { success: false, error: error.message }
    }
  },

  async getTerminalInfo() {
    try {
      const response = await fetch(`${PDQ_BASE_URL}/getTerminalInfo`)
      const data = await response.json()
      
      if (data.ErrCode === 0 && data.ErrMsg.error_code === 0) {
        return { success: true, info: data.ErrMsg }
      } else {
        notify.alert.error('Failed to get terminal info')
        return { success: false, error: data.ErrMsg }
      }
    } catch (error) {
      notify.alert.error('Failed to retrieve terminal information')
      return { success: false, error: error.message }
    }
  },

  async selectDevice(bankId = 'KCB_BANK') {
    try {
      const response = await fetch(`${PDQ_BASE_URL}/selectDevice?bank_id=${bankId}`, {
        method: 'POST'
      })
      const data = await response.json()
      
      if (data.ErrCode === 0) {
        return { success: true, message: data.ErrMsg }
      } else {
        notify.alert.error('Failed to select bank device')
        return { success: false, error: data.ErrMsg }
      }
    } catch (error) {
      notify.alert.error('Bank device selection failed')
      return { success: false, error: error.message }
    }
  },

  async purchase(amount, orderNo) {
    try {
      const formattedAmount = amount * 100; // This is to convert the amount to be handled correctly by POS
      const response = await fetch(`${PDQ_BASE_URL}/purchase?amount=${formattedAmount}&orderNo=${orderNo}`, {
        method: 'POST'
      })
      const data = await response.json()
      
      if (data.ErrCode === 0) {
        const result = data.ErrMsg
        
        if (result.error_code === 0) {
          notify.alert.success('Transaction approved successfully')
          return { 
            success: true, 
            status: 'approved',
            transaction: result 
          }
        } else if (result.error_code === 12324) {
          notify.alert.warning('Duplicate transaction order number')
          return { 
            success: false, 
            status: 'duplicate',
            transaction: result 
          }
        } else if (result.trans_status === 2) {
          notify.alert.error(`Transaction declined: ${result.error_info}`)
          return { 
            success: false, 
            status: 'declined',
            transaction: result 
          }
        } else {
          notify.alert.error(`Transaction failed: ${result.error_info}`)
          return { 
            success: false, 
            status: 'failed',
            transaction: result 
          }
        }
      } else {
        notify.alert.error('PDQ purchase request failed')
        return { success: false, error: data.ErrMsg }
      }
    } catch (error) {
      notify.alert.error('PDQ transaction failed')
      return { success: false, error: error.message }
    }
  },

  async queryTransaction(orderNo) {
    try {
      const response = await fetch(`${PDQ_BASE_URL}/queryTransaction?orderNo=${orderNo}`, {
        method: 'POST'
      })
      const data = await response.json()
      
      if (data.ErrCode === 0) {
        const result = data.ErrMsg
        
        if (result.error_code === 0) {
          return { 
            success: true, 
            transaction: result 
          }
        } else {
          notify.alert.error(`Query failed: ${result.error_info}`)
          return { 
            success: false, 
            transaction: result 
          }
        }
      } else {
        notify.alert.error('Transaction query failed')
        return { success: false, error: data.ErrMsg }
      }
    } catch (error) {
      notify.alert.error('Failed to query transaction')
      return { success: false, error: error.message }
    }
  },

  async purchaseVoid(orderNo, originalOrderNo) {
    try {
      const response = await fetch(`${PDQ_BASE_URL}/purchaseVoid?orderNo=${orderNo}&originalOrderNo=${originalOrderNo}`, {
        method: 'POST'
      })
      const data = await response.json()
      
      if (data.ErrCode === 0) {
        const result = data.ErrMsg
        
        if (result.error_code === 0) {
          notify.alert.success('Transaction voided successfully')
          return { 
            success: true, 
            status: 'voided',
            transaction: result 
          }
        } else if (result.trans_status === 2) {
          notify.alert.error(`Void declined: ${result.error_info}`)
          return { 
            success: false, 
            status: 'declined',
            transaction: result 
          }
        } else {
          notify.alert.error(`Void failed: ${result.error_info}`)
          return { 
            success: false, 
            status: 'failed',
            transaction: result 
          }
        }
      } else {
        notify.alert.error('Purchase void request failed')
        return { success: false, error: data.ErrMsg }
      }
    } catch (error) {
      notify.alert.error('Failed to void transaction')
      return { success: false, error: error.message }
    }
  },

  async initializePDQ(bankId = 'KCB_BANK') {
    const listResult = await this.listDevice()
    if (!listResult.success) {
      return { success: false, step: 'list', error: listResult.error }
    }

    const connectResult = await this.connectDevice()
    if (!connectResult.success) {
      return { success: false, step: 'connect', error: connectResult.error }
    }

    const selectResult = await this.selectDevice(bankId)
    if (!selectResult.success) {
      return { success: false, step: 'select', error: selectResult.error }
    }

    // const terminalInfo = await this.getTerminalInfo()
    // if (!terminalInfo.success) {
    //   return { success: false, step: 'terminal_info', error: terminalInfo.error }
    // }

    // notify.alert.success('PDQ device initialized successfully')
    return { 
      success: true, 
      // terminalInfo: terminalInfo.info
    }
  }
}
